const events = {
	view: 'view',
	click: 'click'
};

const locale = {
	ru: events,
	uk: events,
	en: events,
	de: events,
	vi: events,
	th: events
};

module.exports = {
	enum: events,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/popup-events.js